import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation DeleteMosaicPageForDev(
    $tenantId: ID!
    $zoneId: ID!
    $identifier: FlexibleIdentifierInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        mosaicDev {
          deletePage(identifier: $identifier)
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.DeleteMosaicPageForDevMutation,
  undefined,
  graphql.schema.DeleteMosaicPageForDevMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
